  document.addEventListener('DOMContentLoaded', function() {
    const shareButtons = document.querySelectorAll('.share-button');
    shareButtons.forEach(button => {
      button.addEventListener('click', function() {
        if (navigator.share) {
          navigator.share({
            title: 'Producto',
            text: '!Pensé que podría gustarte esto!',
            url: window.location.href
          }).then(() => {
            console.log('Producto compartido exitosamente');
          }).catch((error) => {
            console.error('Error al compartir', error);
          });
        } else {

        }
      });
    });
  });
